import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, get } from './constants';
import isNumeric from './utils/isNumeric';
import theme from './theme';
import sx from './sx';
import StyledOcticon from './StyledOcticon';
var variantSizes = {
  small: 56,
  medium: 96,
  large: 128
};

var sizeStyles = function sizeStyles(_ref) {
  var size = _ref.size,
      variant = _ref.variant;
  var calc = isNumeric(size) ? size : variantSizes[variant];
  return {
    width: calc,
    height: calc
  };
};

var CircleBadge = styled.div.withConfig({
  displayName: "CircleBadge",
  componentId: "sc-19eysyj-0"
})(["display:", ";align-items:center;justify-content:center;background-color:", ";border-radius:50%;box-shadow:", ";", " ", ";", ";"], function (props) {
  return props.inline ? 'inline-flex' : 'flex';
}, get('colors.white'), get('shadows.medium'), COMMON, sizeStyles, sx);

CircleBadge.Icon = function (props) {
  return /*#__PURE__*/React.createElement(StyledOcticon, _extends({}, props, {
    sx: Object.assign(props.sx, {
      height: 'auto',
      maxWidth: '60%',
      maxHeight: '55%'
    })
  }));
};

CircleBadge.defaultProps = {
  inline: false,
  theme: theme,
  variant: 'medium'
};
CircleBadge.propTypes = _objectSpread(_objectSpread({
  inline: PropTypes.bool,
  size: PropTypes.number,
  theme: PropTypes.object,
  variant: PropTypes.oneOf(['small', 'medium', 'large'])
}, COMMON.propTypes), sx.propTypes);
CircleBadge.Icon.defaultProps = {
  theme: theme,
  sx: {}
};
CircleBadge.Icon.propTypes = _objectSpread({}, StyledOcticon.propTypes);
CircleBadge.Icon.displayName = 'CircleBadge.Icon';
export default CircleBadge;